const sortByName = (nameA: string, nameB: string, revert: boolean) => {
  if (revert) {
    return nameB.localeCompare(nameA)
  }

  return nameA.localeCompare(nameB)
}

const sortByStat = (
  statA: ControleQualiteStatistiqueResponse,
  statB: ControleQualiteStatistiqueResponse,
  revert: boolean
) => {
  const scoreA = (statA && statA.tauxConformiteMoyen) || 0
  const scoreB = (statB && statB.tauxConformiteMoyen) || 0

  if (revert) {
    return scoreA - scoreB
  }

  return scoreB - scoreA
}

const sortSocietesBy = (
  itemA: SocieteResponse,
  itemB: SocieteResponse,
  statA: ControleQualiteStatistiqueResponse,
  statB: ControleQualiteStatistiqueResponse,
  sort: 'name' | 'score',
  revert: boolean
) => {
  if (sort === 'name') {
    return sortByName(itemA.nameSociete, itemB.nameSociete, revert)
  }

  return sortByStat(statA, statB, revert)
}

export { sortSocietesBy }
